import { isNil } from 'lodash-es';
import type React from 'react';
import Spinner from '../../components/layout/Spinner/Spinner';
import { ROUTES } from '../../constants/Constants';
import useAppNavigation from '../../hooks/useAppNavigation';
import useUser from '../../hooks/useUser';

type Props = {
  children: React.ReactNode;
};

const UserRoute = ({ children }: Props) => {
  const { isLoggedIn, currentUser } = useUser();
  const { navigate, toLocalizedRoute } = useAppNavigation();

  if (!isLoggedIn) {
    console.log('User. You shall not pass! 🧙');
    navigate(toLocalizedRoute(ROUTES.HOME_ROUTE), { replace: true });
  }

  // Read user data before (use a loader) and just then open the page
  if (isNil(currentUser)) {
    return (
      <div className="flex min-h-screen min-w-full grow flex-col items-center justify-center">
        <Spinner color="fill-sky-600" />
      </div>
    );
  }

  return children;
};

export default UserRoute;
